import { render, staticRenderFns } from "./configs.html?vue&type=template&id=49348bc4&scoped=true&external"
import script from "./configs.js?vue&type=script&lang=js&external"
export * from "./configs.js?vue&type=script&lang=js&external"
import style0 from "./configs.scss?vue&type=style&index=0&id=49348bc4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49348bc4",
  null
  
)

export default component.exports